import "./Intro.scss";

const Intro = () => {
  return (
    <section className="intro">
      <div className="intro__container">
        <div className="intro__content fade-in">
          <h1 className="intro__title">
            Hey, I'm <span className="intro__highlight">Zakariyya</span>
          </h1>
          <p className="intro__description">
            Mid Level Product Developer at AND Digital, specialising in creating
            intuitive and performant web and mobile experiences
          </p>
          <div className="intro__cta">
            <a href="/contact-me" className="intro__button">
              Get in touch
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
